import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-meldung-entfernen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentMeldungEntfernenEffects {

    IncidentMeldungEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_MELDUNG_ENTFERNEN),
        mergeMap((x: ac.PostIncidentMeldungEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentMeldungEntfernen(x.incidentMeldungRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentMeldungEntfernenErfolgreichAction(result, x.incidentMeldungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentMeldungEntfernenFehlerAction(error, x.incidentMeldungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
